import { cloneDeep } from 'lodash';
import { isEmpty } from '@/common/utils/Util';

export default {
  setDetail: (state, data) => {
    state.detail = data;
  },
  setList: (state, list) => {
    state.list = [...state.list, ...list];
  },
  setNewList: (state, list) => {
    state.list = list;
  },
  initPage: state => {
    state.condition.page = 1;
    state.condition.limit = 10;
    state.condition.userNo = '';
    state.pageInfo.totalPage = 2;
    state.list = [];
  },
  setCondition: (state, data) => {
    state.condition = data;
  },
  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },
  setRegisterCategory(state, category) {
    state.register.category = category;
  }
};
